import validator from 'validator';

export function isBrazilian(nationality: string): boolean {
  return nationality.toLowerCase() === 'br';
}

export function validatePhone(phone: string, isForeigner: boolean): boolean {
  if (!phone || phone.trim() === '') return isForeigner;
  if (isForeigner) {
    let normalized = phone.trim().replace(/\s/g, '');
    if (!normalized.startsWith('+')) normalized = '+' + normalized;
    // E.164: + seguido de 7–15 dígitos (aceita celular, fixo e DDG)
    return /^\+\d{7,15}$/.test(normalized);
  }
  return validator.isMobilePhone(phone.replace(/\D/g, ''), 'pt-BR');
}
